@if (exploreEntity$ | async; as exploreEntity) {
  <a [queryParams]="getBackQueryParams()" [routerLink]="getBackUrl()" aria-label="précédent"
    class="compass__back__link">
    <mat-icon svgIcon="back"></mat-icon>
    <span>{{ 'compass.home' | translate }}</span>
  </a>
  <section>
    <div [ngClass]="'map-theme-' + exploreEntity.get('key')" class="compass-themes__header map-theme">
      <h2>{{ exploreEntity.get('label') }}</h2>
      <p>{{ exploreEntity.get('description') }}</p>
    </div>
  </section>
  <section>
    <div class="compass-themes__content">
      @if (isFiltersActive) {
        <div class="compass-themes__filter">
          <mat-form-field appearance="fill" class="chip-list compass-themes__filter__list">
            <mat-chip-grid #chipList aria-label="selected chip list">
              @for (item of entitiesForFilter; track item) {
                <mat-chip-row
                  (removed)="onThemeFilterRemoveClick(item)"
                  >
                  {{ item.get('label') }}
                  <button [attr.aria-label]="'remove ' + item.get('label')" data-e2e="compass-themes-remove-theme-filter" matChipRemove>
                    <mat-icon matChipRemove svgIcon="cross"></mat-icon>
                  </button>
                </mat-chip-row>
              }
            </mat-chip-grid>
            <input
              #filterInput
              (matChipInputTokenEnd)="onThemeFilterInputSubmit($event)"
              [formControl]="filterCtrl"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              placeholder="Tous les types...">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onThemeFilterSelected($event)">
                @for (item of entitiesFiltered | async; track item) {
                  <mat-option appAriaTitle [value]="item">
                    {{ item.get('label') }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <!------------------------------------- LEVELS ------------------------------------->
            <mat-form-field appearance="fill" class="levels-chip-list compass-themes__filter__list__levels">
              <mat-chip-grid #levelsList aria-label="Level selection">
                @for (level of levels; track level) {
                  <mat-chip-row
                    (removed)="onLevelRemoveClick(level)"
                    >
                    {{ level.get('label') }}
                    <button data-e2e="compass-themes-remove-level-filter" matChipRemove>
                      <mat-icon matChipRemove svgIcon="cross"></mat-icon>
                    </button>
                  </mat-chip-row>
                }
              </mat-chip-grid>
              <input
                #levelInput
                (matChipInputTokenEnd)="onLevelInputSubmit($event)"
                [formControl]="levelCtrl"
                [matAutocomplete]="autoLevel"
                [matChipInputFor]="levelsList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                placeholder="Tous les niveaux..."
                >
                <mat-autocomplete #autoLevel="matAutocomplete" (optionSelected)="onLevelSelected($event)">
                  @for (level of levelsFiltered | async; track level) {
                    <mat-option appAriaTitle [value]="level">
                      {{ level.get('label') }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              @if (levels?.length || entitiesForFilter?.length) {
                <button data-e2e="compass-themes-reset-filters" (click)="onResetFiltersClick()">
                  <mat-icon svgIcon="trash"></mat-icon>
                  <span>{{ 'generic.delete' | translate }}</span>
                </button>
              }
            </div>
          }
          @if (!displayLoader) {
            <div class="compass-themes-filter-diagnostic">
              <div class="grid-compass">
                @for (theme of themes; track theme) {
                  <app-compass-card
                    [ngStyle]="{'background-image': 'url(' + (theme.get('medias') && theme.get('medias')[0] ? theme.get('medias')[0].url : '') + ')'}"
                    class="compass-card--resources map-theme map-theme-{{filterType}}">
                    <div class="app-compass-card__header" data-header>
                      <app-keywords>
                        @for (tag of (theme.get('tags') || []); track tag) {
                          <span class="keywords__item"
                            itemprop="keywords">
                            {{ tag.name }}
                          </span>
                        }
                      </app-keywords>
                    </div>
                    <div class="app-compass-card__body"
                         [ngClass]="{'app-compass-card__body--no-medias':theme.get('medias').length === 0}" data-body>
                      <h3 [innerHTML]="theme.get('label')"></h3>
                      <div [innerHTML]="theme.get('body')"></div>
                    </div>
                    <div class="app-compass-card__footer" data-footer>
                      <a
                        [queryParams]="getThemeQueryParams(exploreEntity, theme)"
                        [routerLink]="['themes', theme.id, 'ressources']"
                        class="app-compass-card__footer__button">
                        <mat-icon svgIcon="app-compass-card__footer__button__icon"></mat-icon>
                        <span>{{ 'compass.see_resources' | translate }}</span>
                      </a>
                    </div>
                  </app-compass-card>
                }
              </div>
            </div>
          }
        </div>
      </section>
    }

    @if (displayLoader) {
      <ng-container #loader>
        <mat-spinner [diameter]="60" [strokeWidth]="5"></mat-spinner>
      </ng-container>
    }
